// Vue's out-in transition leaves the previous page mounted during its fade.
// Wait for removal before moving the viewport to the new page's scroll target.
export function waitForRouteExit(element) {
  if (!element?.isConnected) return Promise.resolve();
  return new Promise(resolve => {
    const parent = element.parentNode;
    if (!parent) { resolve(); return; }
    const observer = new MutationObserver(() => {
      if (element.isConnected) return;
      observer.disconnect();
      resolve();
    });
    observer.observe(parent, { childList: true });
  });
}

let pendingArrival = null;

// Route transitions and layout must finish mounting the destination before
// Vue Router restores an offset. Superseding a navigation releases its wait.
export function prepareRouteArrival(route) {
  pendingArrival?.enter();
  let enter;
  const ready = new Promise(resolve => { enter = resolve; });
  pendingArrival = route ? { route, ready, enter } : null;
}

export function getRouteArrival(route) {
  return pendingArrival?.route === route ? pendingArrival : null;
}

export function markRouteArrived(route) {
  getRouteArrival(route)?.enter();
}

let pendingReturn = null;

export function prepareRouteReturn(route, top) {
  clearRouteReturn(pendingReturn);
  let enter;
  const ready = new Promise(resolve => { enter = resolve; });
  pendingReturn = { route, top: Math.max(0, Number(top) || 0), ready, enter };
  return pendingReturn;
}

export function getRouteReturn(route) {
  return pendingReturn?.route === route ? pendingReturn : null;
}

export function markReturnRouteEntered(route) {
  getRouteReturn(route)?.enter();
}

export function clearRouteReturn(intent) {
  if (!intent) return;
  intent.enter();
  if (pendingReturn === intent) pendingReturn = null;
}
